import { useQuery } from '@tanstack/react-query';
import { getDarts } from '~/api';
import { MINUTE } from '~/constants';
import dartKey from './dartKey';

const useGetDartsQuery = () => {
  return useQuery({
    queryKey: dartKey.getDarts(),
    queryFn: () => getDarts(),
    refetchInterval: 5 * MINUTE,
    refetchOnMount: true,
    staleTime: 0,
    gcTime: 5 * MINUTE,
    select: ({ data, status }) => data.dart,
  });
};

export default useGetDartsQuery;
